import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { User } from "@ecologi/shared";
import { useStore } from "../../../store";
import { formatAPIErrorForView, updateUser, APIError } from "../../../lib";

export function useUpdateProfile(successMessage: string) {
  const { setUser, setLocation } = useStore();

  const [updateUserMutation] = useMutation(updateUser, {
    onSuccess: ({ user }) => {
      const updatedUser = new User(user);
      setUser(updatedUser);
      setLocation({ countryCode: updatedUser.location });
      toast.success(successMessage);
    },
    onError: (error: APIError) => {
      toast.error(formatAPIErrorForView(error));
    },
  });

  return updateUserMutation;
}
